import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    Col,
    Label,
    Nav,
    NavItem,
    NavLink,
    Row,
    Spinner,
    TabContent,
    TabPane,
    Table
} from "reactstrap";

import { AvField, AvForm } from "availity-reactstrap-validation";
import axios from "axios";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../services/api";
import { setBreadcrumbItems } from "../../store/actions";


const AddCourseDiscount = (props) => {

    const navigate = useNavigate();

    document.title = "Technical Hub | Course Discounts";

    const breadcrumbItems = [
        { title: "Technical Hub", link: "#" },
        { title: "Course Discounts", link: "#" },
        { title: "Add Course Discount", link: "#" },
    ];

    const backendUrl = process.env.REACT_APP_BACKEND_URL;


    // ============================================================
    // PAGE MODE
    // ============================================================

    const [discountMode, setDiscountMode] = useState("single");


    // ============================================================
    // COMMON DATA
    // ============================================================

    const [courses, setCourses] = useState([]);

    const [technologies, setTechnologies] = useState({
        technology_id: "",
        technology_name: "",
        technology_icon: ""
    });

    const [selectedCourse, setSelectedCourse] = useState(null);

    const [programName, setProgramName] = useState([]);

    const [selectedProgramName, setSelectedProgramName] = useState(null);

    const [technologyName, setTechnologyName] = useState(null);

    const [selectedTechnologyName, setSelectedTechnologyName] =
        useState(null);

    const [termFeeOptions, setTermFeeOptions] = useState([]);

    const [termFeeDetails, setTermFeeDetails] = useState([]);

    const [selectedTermName, setSelectedTermName] = useState(null);

    const [addedby, setAddedBy] = useState("admin");

    const [loggedInUser, setLoggedInUser] = useState(null);

    const [selectedDiscountType, setSelectedDiscountType] =
        useState(null);

    const [submitting, setSubmitting] = useState(false);


    // ============================================================
    // BULK DISCOUNT STATES
    // ============================================================

    const [bulkPassoutYear, setBulkPassoutYear] = useState("");

    const [bulkFile, setBulkFile] = useState(null);

    const [bulkFileInputKey, setBulkFileInputKey] =
        useState(Date.now());

    const [bulkValidating, setBulkValidating] =
        useState(false);

    const [bulkApplying, setBulkApplying] =
        useState(false);

    const [bulkPreview, setBulkPreview] =
        useState(null);

    const [bulkActiveTab, setBulkActiveTab] =
        useState("1");


    // ============================================================
    // INITIAL LOAD
    // ============================================================

    useEffect(() => {

        const curr_user =
            JSON.parse(localStorage.getItem("authUser"));

        if (curr_user) {
            setAddedBy(curr_user.first_name);
            setLoggedInUser(curr_user);
        }

        getCourses();

        props.setBreadcrumbItems(
            "Course Discounts",
            breadcrumbItems
        );

    }, []);


    // ============================================================
    // GET COURSES
    // ============================================================

    const getCourses = async () => {

        try {

            const response =
                await axios.get(
                    `${backendUrl}get-courses`
                );

            if (response.status === 200) {
                setCourses(response.data);
            }

        } catch (err) {

            console.log(err);

            toast.error(
                "Unable to load courses."
            );
        }
    };


    // ============================================================
    // GET PROGRAM NAMES
    // ============================================================

    useEffect(() => {

        const getProgramNames = async () => {

            if (!selectedCourse?.value) {
                setProgramName([]);
                return;
            }

            try {

                const response =
                    await axios.get(
                        `${backendUrl}get-programs-by-course-id/${selectedCourse.value}`
                    );

                if (response.status === 200) {

                    setProgramName(
                        response.data.coursePrograms || []
                    );
                }

            } catch (err) {

                console.log(err);

                setProgramName([]);
            }
        };

        getProgramNames();

    }, [selectedCourse, backendUrl]);


    const currentYear = new Date().getFullYear();

    const passoutYearOptions = Array.from(
        { length: currentYear + 6 - 2016 + 1 },
        (_, index) => 2016 + index
    );

    // ============================================================
    // GET TECHNOLOGIES BY PROGRAM
    // ============================================================

    useEffect(() => {

        const getTechnologyByProgram = async () => {

            setTechnologyName([]);
            setSelectedTechnologyName(null);

            setTermFeeOptions([]);
            setTermFeeDetails([]);
            setSelectedTermName(null);

            if (!selectedProgramName?.value) {
                return;
            }

            try {

                const encodedProgramName =
                    encodeURIComponent(
                        selectedProgramName.value
                    );

                const response =
                    await axios.get(
                        `${backendUrl}get-technology-by-program/${encodedProgramName}`
                    );

                if (
                    response.status === 200 &&
                    response.data.Technology &&
                    response.data.Technology.length > 0
                ) {

                    setTechnologyName(
                        response.data.Technology
                    );

                } else {

                    setTechnologies({
                        technology_id: "",
                        technology_name: "N/A",
                        technology_icon: ""
                    });
                }

            } catch (err) {

                console.log(err);

                setTechnologyName([]);
            }
        };

        getTechnologyByProgram();

    }, [selectedProgramName, backendUrl]);


    // ============================================================
    // GET COURSE REGISTRATION / TERM DETAILS
    // ============================================================

    useEffect(() => {

        const getCourseRegistrationDetails = async () => {

            if (
                !selectedTechnologyName?.value ||
                !selectedProgramName?.value
            ) {
                setTermFeeDetails([]);
                setTermFeeOptions([]);
                return;
            }

            try {

                const response =
                    await axios.get(
                        `${backendUrl}get-course-registration-by-tech-id/${selectedTechnologyName.value}/${selectedProgramName.value}`
                    );

                if (
                    response.status === 200 &&
                    response.data.data &&
                    response.data.data.length > 0
                ) {

                    const termDetails =
                        response.data.data[0]
                            .term_fee_details || [];

                    setTermFeeDetails(
                        termDetails
                    );

                    const termNameOptions =
                        termDetails.map((ele) => ({
                            label: ele.term_name,
                            value: ele.term_name,
                            amount: ele.amount
                        }));

                    setTermFeeOptions(
                        termNameOptions
                    );
                }

            } catch (err) {

                console.log(err);

                setTermFeeDetails([]);
                setTermFeeOptions([]);
            }
        };

        getCourseRegistrationDetails();

    }, [
        selectedTechnologyName,
        selectedProgramName,
        backendUrl
    ]);


    // ============================================================
    // OPTIONS
    // ============================================================

    const courseOptions =
        courses?.map((ele) => ({
            label: ele.course_name,
            value: ele._id
        })) || [];


    const TechnologyOptions =
        technologyName?.map((ele) => ({
            label: ele.technology_name,
            value: ele.technology_id,
            reg_id: ele._id
        })) || [];


    const programNameOptions =
        programName?.map((ele) => ({
            label: ele.program_name,
            value: ele.program_name
        })) || [];


    const discountTypeOptions = [
        {
            options: [
                {
                    label: "term",
                    value: "term"
                }
            ]
        }
    ];


    // ============================================================
    // SINGLE MODE HANDLERS
    // ============================================================

    const handleSelectedCourse = (selectedOption) => {

        setSelectedCourse(selectedOption);

        setSelectedProgramName(null);
        setSelectedTechnologyName(null);
        setSelectedTermName(null);

        setProgramName([]);
        setTechnologyName([]);
        setTermFeeOptions([]);
        setTermFeeDetails([]);

        setTechnologies({
            technology_id: "",
            technology_name: "",
            technology_icon: ""
        });

        // Also reset bulk data because course changed
        resetBulkPreview();
    };


    const handleSelectedProgramName = (selectedOption) => {

        setSelectedProgramName(
            selectedOption
        );

        setSelectedTechnologyName(null);

        setSelectedTermName(null);

        setTermFeeOptions([]);
        setTermFeeDetails([]);

        resetBulkPreview();
    };


    const handleSelectedTechnology = (selectedOption) => {

        setSelectedTechnologyName(
            selectedOption
        );

        setSelectedTermName(null);

        resetBulkPreview();
    };


    const handleSelectedDiscountType = (
        selectedGroup
    ) => {

        setSelectedDiscountType(
            selectedGroup
        );
    };


    const handleSelectedTermName = (
        option
    ) => {

        setSelectedTermName(option);
    };


    // ============================================================
    // RESET BULK PREVIEW
    // ============================================================

    const resetBulkPreview = () => {

        setBulkPreview(null);

        setBulkActiveTab("1");
    };


    // ============================================================
    // SWITCH MODE
    // ============================================================

    const handleModeChange = (mode) => {

        setDiscountMode(mode);

        if (mode === "bulk") {

            // Bulk should start clean
            setBulkPreview(null);
            setBulkFile(null);
            setBulkPassoutYear("");
            setBulkActiveTab("1");

            setBulkFileInputKey(
                Date.now()
            );
        }
    };


    // ============================================================
    // BULK FILE CHANGE
    // ============================================================

    const handleBulkFileChange = (event) => {

        const file =
            event.target.files?.[0];

        if (!file) {
            setBulkFile(null);
            return;
        }

        const extension =
            file.name
                .split(".")
                .pop()
                .toLowerCase();

        if (
            !["xlsx", "xls"].includes(
                extension
            )
        ) {

            toast.error(
                "Only .xlsx and .xls Excel files are allowed."
            );

            event.target.value = "";

            setBulkFile(null);

            return;
        }

        if (file.size === 0) {

            toast.error(
                "Selected Excel file is empty."
            );

            event.target.value = "";

            setBulkFile(null);

            return;
        }

        setBulkFile(file);

        // New file means previous preview is no longer valid
        setBulkPreview(null);
    };


    // ============================================================
    // CLEAR BULK FILE
    // ============================================================

    const clearBulkFile = () => {

        setBulkFile(null);

        setBulkPreview(null);

        setBulkActiveTab("1");

        setBulkFileInputKey(
            Date.now()
        );
    };


    // ============================================================
    // VALIDATE BULK DISCOUNTS
    // ============================================================

    const handleValidateBulkDiscounts =
        async () => {

            if (!selectedCourse?.value) {

                toast.error(
                    "Please select a course."
                );

                return;
            }

            if (!selectedProgramName?.value) {

                toast.error(
                    "Please select a program name."
                );

                return;
            }

            if (!selectedTechnologyName?.value) {

                toast.error(
                    "Please select a technology."
                );

                return;
            }

            if (!bulkPassoutYear) {

                toast.error(
                    "Please enter passout year."
                );

                return;
            }

            const numericYear =
                Number(bulkPassoutYear);

            if (
                !Number.isInteger(numericYear) ||
                numericYear < 2000 ||
                numericYear > 2100
            ) {

                toast.error(
                    "Please enter a valid passout year."
                );

                return;
            }

            if (!bulkFile) {

                toast.error(
                    "Please select an Excel file."
                );

                return;
            }

            setBulkValidating(true);

            setBulkPreview(null);

            try {

                const formData =
                    new FormData();

                formData.append(
                    "file",
                    bulkFile
                );

                formData.append(
                    "course_id",
                    selectedCourse.value
                );

                formData.append(
                    "technology_id",
                    selectedTechnologyName.value
                );

                formData.append(
                    "passout_year",
                    numericYear
                );

                const response =
                    await api.post(
                        `${backendUrl}validate-bulk-discounts`,
                        formData,
                        {
                            withCredentials: true
                        }
                    );

                if (
                    response.status === 200 &&
                    response.data?.success
                ) {

                    setBulkPreview(
                        response.data
                    );

                    setBulkActiveTab("1");

                    toast.success(
                        "Excel validation completed successfully."
                    );

                } else {

                    toast.error(
                        response.data?.message ||
                        "Unable to validate Excel file."
                    );
                }

            } catch (error) {

                console.error(
                    "Bulk discount validation error:",
                    error
                );

                const message =
                    error.response?.data?.message;

                if (
                    error.response?.status === 401
                ) {

                    toast.error(
                        "Authentication required. Please login again."
                    );

                } else if (
                    error.response?.status === 403
                ) {

                    toast.error(
                        "You are not authorized to perform bulk discounts."
                    );

                } else {

                    toast.error(
                        message ||
                        "Failed to validate bulk discount Excel."
                    );
                }

            } finally {

                setBulkValidating(false);
            }
        };


    // ============================================================
    // APPLY BULK DISCOUNTS
    // ============================================================

    const handleApplyBulkDiscounts =
        async () => {

            if (!bulkPreview) {

                toast.error(
                    "Please validate the Excel file first."
                );

                return;
            }

            const summary =
                bulkPreview.summary || {};

            const validCount =
                Number(summary.valid || 0);

            const invalidCount =
                Number(summary.invalid || 0);

            const duplicateCount =
                Number(summary.duplicate || 0);


            if (validCount === 0) {

                toast.error(
                    "There are no valid students to process."
                );

                return;
            }


            if (
                invalidCount > 0 ||
                duplicateCount > 0
            ) {

                toast.error(
                    "Please correct all invalid and duplicate records before applying bulk discounts."
                );

                return;
            }


            if (!selectedCourse?.value) {

                toast.error(
                    "Course selection is missing."
                );

                return;
            }


            if (!selectedTechnologyName?.value) {

                toast.error(
                    "Technology selection is missing."
                );

                return;
            }


            if (!bulkPassoutYear) {

                toast.error(
                    "Passout year is missing."
                );

                return;
            }


            if (!bulkFile) {

                toast.error(
                    "Excel file is missing."
                );

                return;
            }


            const confirmed =
                window.confirm(
                    `Are you sure you want to apply full term discounts to ${validCount} student(s)?`
                );

            if (!confirmed) {
                return;
            }


            setBulkApplying(true);


            try {

                const formData =
                    new FormData();

                formData.append(
                    "file",
                    bulkFile
                );

                formData.append(
                    "course_id",
                    selectedCourse.value
                );

                formData.append(
                    "technology_id",
                    selectedTechnologyName.value
                );

                formData.append(
                    "passout_year",
                    Number(bulkPassoutYear)
                );


                const response =
                    await api.post(
                        `${backendUrl}bulk-add-discounts`,
                        formData,
                        {
                            withCredentials: true
                        }
                    );


                if (
                    response.status === 200 ||
                    response.status === 201
                ) {

                    const responseData =
                        response.data || {};

                    toast.success(
                        responseData.message ||
                        `Bulk discounts applied successfully to ${validCount} student(s).`
                    );


                    // Clear bulk workflow
                    setBulkPreview(null);

                    setBulkFile(null);

                    setBulkPassoutYear("");

                    setBulkActiveTab("1");

                    setBulkFileInputKey(
                        Date.now()
                    );


                    // Go to discount list after successful operation
                    setTimeout(() => {

                        navigate(
                            "/course-discounts-list"
                        );

                    }, 2000);

                } else {

                    toast.error(
                        response.data?.message ||
                        "Bulk discount operation failed."
                    );
                }

            } catch (error) {

                console.error(
                    "Bulk discount creation error:",
                    error
                );

                const message =
                    error.response?.data?.message;

                if (
                    error.response?.status === 400
                ) {

                    toast.error(
                        message ||
                        "Bulk discount validation failed."
                    );

                } else if (
                    error.response?.status === 401
                ) {

                    toast.error(
                        "Authentication required. Please login again."
                    );

                } else if (
                    error.response?.status === 403
                ) {

                    toast.error(
                        "You are not authorized to apply bulk discounts."
                    );

                } else {

                    toast.error(
                        message ||
                        "Failed to apply bulk discounts."
                    );
                }

            } finally {

                setBulkApplying(false);
            }
        };


    // ============================================================
    // SINGLE DISCOUNT - FULL DISCOUNT SETTLEMENT
    // ============================================================

    const settleFullDiscountTerm =
        async (fullDiscountItem) => {

            const payload = {

                zero_payment_status: 0,

                cash_counter_name:
                    loggedInUser?.college,

                cashier_name:
                    loggedInUser?.first_name,

                roll_no:
                    fullDiscountItem.roll_no,

                reg_id:
                    selectedTechnologyName?.reg_id,

                technology_id:
                    selectedTechnologyName?.value,

                course_id:
                    selectedCourse?.value,

                term_name:
                    fullDiscountItem.term_name,

                amount: 0,

                discount:
                    fullDiscountItem.amount,

                remarks:
                    fullDiscountItem.remarks ||
                    "Full discount",
            };

            return api.post(
                `${backendUrl}create-fee-payment`,
                payload
            );
        };


    // ============================================================
    // SINGLE DISCOUNT SUBMIT
    // ============================================================

    const handleSubmit =
        async (event, values) => {

            if (submitting) return;


            if (!selectedCourse?.value) {

                toast.error(
                    "Please select a course."
                );

                return;
            }


            if (!selectedProgramName?.value) {

                toast.error(
                    "Please select a program name."
                );

                return;
            }


            if (!selectedDiscountType?.value) {

                toast.error(
                    "Please select a discount type."
                );

                return;
            }


            let finalDiscountDetails = [];


            if (
                selectedDiscountType?.value ===
                "term"
            ) {

                if (!selectedTermName?.value) {

                    toast.error(
                        "Please select a term name."
                    );

                    return;
                }


                const term =
                    termFeeDetails.find(
                        (ele) =>
                            ele.term_name ===
                            selectedTermName.value
                    );


                if (!term) {

                    toast.error(
                        "Term fee details not found."
                    );

                    return;
                }


                const discountAmount =
                    Number(term.amount);


                if (
                    !discountAmount ||
                    discountAmount <= 0
                ) {

                    toast.error(
                        "Invalid term fee amount."
                    );

                    return;
                }


                finalDiscountDetails = [
                    {
                        term_name:
                            selectedTermName.value,

                        amount:
                            discountAmount,

                        remarks:
                            values.remarks
                    }
                ];
            }


            const payload = {

                roll_no:
                    values.rollNo || "",

                reg_id:
                    selectedTechnologyName?.reg_id,

                course_id:
                    selectedCourse?.value,

                technology_id:
                    selectedTechnologyName?.value,

                discount_type:
                    selectedDiscountType?.value,

                discount_details:
                    finalDiscountDetails,

                added_by:
                    addedby || "admin"
            };


            setSubmitting(true);


            try {

                const response =
                    await api.post(
                        `${backendUrl}add-discount`,
                        payload
                    );


                if (
                    response.status === 200 ||
                    response.status === 201
                ) {


                    // ====================================================
                    // FIND FULL DISCOUNT TERMS
                    // ====================================================

                    const fullDiscountTerms =
                        finalDiscountDetails.filter(
                            (item) => {

                                const term =
                                    termFeeDetails.find(
                                        (t) =>
                                            t.term_name ===
                                            item.term_name
                                    );

                                return (
                                    term &&
                                    Number(item.amount) ===
                                    Number(term.amount)
                                );
                            }
                        );


                    const partialDiscountTerms =
                        finalDiscountDetails.filter(
                            (item) =>
                                !fullDiscountTerms.includes(
                                    item
                                )
                        );


                    let settlementFailed =
                        false;

                    let failedTermNames = [];


                    // ====================================================
                    // AUTO SETTLEMENT
                    // ====================================================

                    if (
                        fullDiscountTerms.length >
                        0
                    ) {

                        const settlementResults =
                            await Promise.allSettled(

                                fullDiscountTerms.map(
                                    (item) =>
                                        settleFullDiscountTerm({
                                            ...item,
                                            roll_no:
                                                values.rollNo ||
                                                ""
                                        })
                                )
                            );


                        settlementResults.forEach(
                            (result, idx) => {

                                if (
                                    result.status ===
                                    "rejected"
                                ) {

                                    settlementFailed =
                                        true;

                                    failedTermNames.push(
                                        fullDiscountTerms[
                                            idx
                                        ].term_name
                                    );
                                }
                            }
                        );
                    }


                    // ====================================================
                    // RESULT MESSAGE
                    // ====================================================

                    if (
                        settlementFailed
                    ) {

                        toast.error(
                            `Discount was created, but the full-discount payment settlement failed for ${failedTermNames.join(
                                ", "
                            )}. Please verify the payment record.`
                        );

                    } else {

                        const hasFull =
                            fullDiscountTerms.length >
                            0;

                        const hasPartial =
                            partialDiscountTerms.length >
                            0;


                        let successMsg =
                            response.data?.message ||
                            "Discount added or updated successfully!";


                        if (
                            hasFull &&
                            hasPartial
                        ) {

                            successMsg =
                                "Discount added successfully. Full-discount terms have been settled and partial-discount terms remain payable at the cashier.";

                        } else if (
                            hasFull
                        ) {

                            successMsg =
                                "Full discount added successfully. The term has been settled.";

                        } else if (
                            hasPartial
                        ) {

                            successMsg =
                                "Discount added successfully. The remaining balance will be payable at the cashier.";
                        }


                        toast.success(
                            successMsg
                        );


                        setTimeout(() => {

                            navigate(
                                "/course-discounts-list"
                            );

                        }, 2000);
                    }
                }

            } catch (error) {

                console.error(
                    "Error adding discount:",
                    error
                );


                if (
                    error.response &&
                    error.response.status ===
                    400 &&
                    error.response.data.message
                ) {

                    toast.error(
                        error.response.data.message
                    );

                } else if (
                    error.response &&
                    error.response.status ===
                    401
                ) {

                    toast.error(
                        "Authentication required. Please login again."
                    );

                } else if (
                    error.response &&
                    error.response.status ===
                    403
                ) {

                    toast.error(
                        "You are not authorized."
                    );

                } else if (
                    error.response &&
                    error.response.status ===
                    500
                ) {

                    toast.error(
                        "Internal server error. Please try again later."
                    );

                } else {

                    toast.error(
                        "An unexpected error occurred. Please try again."
                    );
                }

            } finally {

                setSubmitting(false);
            }
        };


    // ============================================================
    // BULK SUMMARY
    // ============================================================

    const bulkSummary =
        bulkPreview?.summary || {
            total_rows: 0,
            valid: 0,
            invalid: 0,
            duplicate: 0
        };


    const canApplyBulk =
        bulkPreview &&
        Number(bulkSummary.valid || 0) > 0 &&
        Number(bulkSummary.invalid || 0) === 0 &&
        Number(bulkSummary.duplicate || 0) === 0;


    // ============================================================
    // RENDER VALID STUDENTS
    // ============================================================

    const renderValidStudents = () => {

        const students =
            bulkPreview?.valid_students || [];


        if (students.length === 0) {

            return (
                <div className="text-center p-4">
                    <p className="text-muted mb-0">
                        No valid students found.
                    </p>
                </div>
            );
        }


        return (
            <div
                style={{
                    overflowX: "auto",
                    maxHeight: "450px",
                    overflowY: "auto"
                }}
            >

                <Table
                    bordered
                    hover
                    responsive
                    className="mb-0"
                >

                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Roll No</th>
                            <th>Term</th>
                            <th>Term Fee</th>
                            <th>Discount</th>
                            <th>Payment</th>
                            <th>Balance</th>
                            <th>Remarks</th>
                        </tr>
                    </thead>

                    <tbody>

                        {students.map(
                            (student, index) => (

                                <tr
                                    key={`${student.roll_no}-${student.term_name}-${index}`}
                                >

                                    <td>
                                        {index + 1}
                                    </td>

                                    <td>
                                        <strong>
                                            {student.roll_no}
                                        </strong>
                                    </td>

                                    <td>
                                        {student.term_name}
                                    </td>

                                    <td>
                                        ₹
                                        {Number(
                                            student.term_amount ||
                                            0
                                        ).toLocaleString("en-IN")}
                                    </td>

                                    <td>
                                        ₹
                                        {Number(
                                            student.discount_amount ||
                                            0
                                        ).toLocaleString("en-IN")}
                                    </td>

                                    <td>
                                        ₹
                                        {Number(
                                            student.payment_amount ||
                                            0
                                        ).toLocaleString("en-IN")}
                                    </td>

                                    <td>
                                        ₹
                                        {Number(
                                            student.balance ||
                                            0
                                        ).toLocaleString("en-IN")}
                                    </td>

                                    <td>
                                        {student.remarks ||
                                            "-"}
                                    </td>

                                </tr>
                            )
                        )}

                    </tbody>

                </Table>

            </div>
        );
    };


    // ============================================================
    // RENDER INVALID STUDENTS
    // ============================================================

    const renderInvalidStudents = () => {

        const students =
            bulkPreview?.invalid_students || [];


        if (students.length === 0) {

            return (
                <div className="text-center p-4">
                    <p className="text-success mb-0">
                        No invalid records.
                    </p>
                </div>
            );
        }


        return (
            <div
                style={{
                    overflowX: "auto",
                    maxHeight: "450px",
                    overflowY: "auto"
                }}
            >

                <Table
                    bordered
                    hover
                    responsive
                    className="mb-0"
                >

                    <thead>
                        <tr>
                            <th>Excel Row</th>
                            <th>Roll No</th>
                            <th>Term</th>
                            <th>Remarks</th>
                            <th>Reason</th>
                        </tr>
                    </thead>

                    <tbody>

                        {students.map(
                            (student, index) => (

                                <tr
                                    key={`${student.roll_no}-${student.term_name}-${index}`}
                                >

                                    <td>
                                        {student.row_number ||
                                            "-"}
                                    </td>

                                    <td>
                                        {student.roll_no ||
                                            "-"}
                                    </td>

                                    <td>
                                        {student.term_name ||
                                            "-"}
                                    </td>

                                    <td>
                                        {student.remarks ||
                                            "-"}
                                    </td>

                                    <td className="text-danger">
                                        {student.message ||
                                            "Invalid record"}
                                    </td>

                                </tr>
                            )
                        )}

                    </tbody>

                </Table>

            </div>
        );
    };


    // ============================================================
    // RENDER DUPLICATE STUDENTS
    // ============================================================

    const renderDuplicateStudents = () => {

        const students =
            bulkPreview?.duplicate_students || [];


        if (students.length === 0) {

            return (
                <div className="text-center p-4">
                    <p className="text-success mb-0">
                        No duplicate records.
                    </p>
                </div>
            );
        }


        return (
            <div
                style={{
                    overflowX: "auto",
                    maxHeight: "450px",
                    overflowY: "auto"
                }}
            >

                <Table
                    bordered
                    hover
                    responsive
                    className="mb-0"
                >

                    <thead>
                        <tr>
                            <th>Excel Row</th>
                            <th>Roll No</th>
                            <th>Term</th>
                            <th>Remarks</th>
                            <th>Reason</th>
                        </tr>
                    </thead>

                    <tbody>

                        {students.map(
                            (student, index) => (

                                <tr
                                    key={`${student.roll_no}-${student.term_name}-${index}`}
                                >

                                    <td>
                                        {student.row_number ||
                                            "-"}
                                    </td>

                                    <td>
                                        {student.roll_no ||
                                            "-"}
                                    </td>

                                    <td>
                                        {student.term_name ||
                                            "-"}
                                    </td>

                                    <td>
                                        {student.remarks ||
                                            "-"}
                                    </td>

                                    <td className="text-warning">
                                        {student.message ||
                                            "Duplicate record"}
                                    </td>

                                </tr>
                            )
                        )}

                    </tbody>

                </Table>

            </div>
        );
    };


    // ============================================================
    // MAIN UI
    // ============================================================

    return (

        <React.Fragment>

            <Row>

                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                    transition={Bounce}
                />


                <Col xl="12">

                    <Card>

                        <CardBody>

                            {/* ==================================================
                                HEADER
                            ================================================== */}

                            <div
                                className="d-flex justify-content-between align-items-center mb-4"
                                style={{
                                    flexWrap: "wrap",
                                    gap: "15px"
                                }}
                            >

                                <div>

                                    <h4 className="card-title mb-1">
                                        Course Discount
                                    </h4>

                                    <p className="text-muted mb-0">
                                        Add individual discounts or apply
                                        discounts in bulk.
                                    </p>

                                </div>


                                {/* ==================================================
                                    SINGLE / BULK TOGGLE
                                ================================================== */}

                                <div
                                    style={{
                                        display: "flex",
                                        border: "1px solid #dee2e6",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        background: "#f8f9fa"
                                    }}
                                >

                                    <Button
                                        type="button"
                                        color={
                                            discountMode ===
                                                "single"
                                                ? "primary"
                                                : "light"
                                        }
                                        onClick={() =>
                                            handleModeChange(
                                                "single"
                                            )
                                        }
                                        style={{
                                            borderRadius: 0,
                                            minWidth: "150px",
                                            fontWeight: 600,
                                            border: "none"
                                        }}
                                    >
                                        Single Discount
                                    </Button>


                                    <Button
                                        type="button"
                                        color={
                                            discountMode ===
                                                "bulk"
                                                ? "primary"
                                                : "light"
                                        }
                                        onClick={() =>
                                            handleModeChange(
                                                "bulk"
                                            )
                                        }
                                        style={{
                                            borderRadius: 0,
                                            minWidth: "150px",
                                            fontWeight: 600,
                                            border: "none"
                                        }}
                                    >
                                        Bulk Discount
                                    </Button>

                                </div>

                            </div>


                            {/* ==================================================
                                SINGLE DISCOUNT
                            ================================================== */}

                            {discountMode ===
                                "single" && (

                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={
                                            handleSubmit
                                        }
                                    >

                                        <Row>

                                            <Col md="4">

                                                <div className="mb-4">

                                                    <Label htmlFor="rollNo">
                                                        Enter Roll no{" "}
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </Label>


                                                    <AvField
                                                        name="rollNo"
                                                        placeholder="Enter Roll No"
                                                        type="text"
                                                        className="form-control"
                                                        id="rollNo"
                                                        maxLength="15"

                                                        onKeyDown={(e) => {

                                                            const allowedKeys =
                                                                [
                                                                    "Backspace",
                                                                    "Delete",
                                                                    "ArrowLeft",
                                                                    "ArrowRight",
                                                                    "Tab"
                                                                ];

                                                            if (
                                                                allowedKeys.includes(
                                                                    e.key
                                                                )
                                                            ) {
                                                                return;
                                                            }

                                                            if (
                                                                e.key ===
                                                                " "
                                                            ) {

                                                                e.preventDefault();

                                                                return;
                                                            }

                                                            const regex =
                                                                /^[A-Za-z0-9]$/;

                                                            if (
                                                                !regex.test(
                                                                    e.key
                                                                )
                                                            ) {

                                                                e.preventDefault();
                                                            }

                                                        }}

                                                        onChange={(e) => {

                                                            let value =
                                                                e.target.value.replace(
                                                                    /[^A-Za-z0-9]/g,
                                                                    ""
                                                                );

                                                            if (
                                                                value.length >
                                                                15
                                                            ) {

                                                                value =
                                                                    value.substring(
                                                                        0,
                                                                        15
                                                                    );
                                                            }

                                                            e.target.value =
                                                                value;
                                                        }}

                                                        validate={{
                                                            required: {
                                                                value: true,
                                                                errorMessage:
                                                                    "Roll No is required"
                                                            },

                                                            pattern: {
                                                                value: "^[A-Za-z0-9]{1,15}$",
                                                                errorMessage:
                                                                    "Only alphabets and numbers allowed, max 15 characters"
                                                            }
                                                        }}
                                                    />

                                                </div>

                                            </Col>


                                            <Col md="4">

                                                <div className="mb-4">

                                                    <Label>
                                                        Select Course{" "}
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </Label>

                                                    <Select
                                                        value={
                                                            selectedCourse
                                                        }
                                                        onChange={
                                                            handleSelectedCourse
                                                        }
                                                        options={
                                                            courseOptions
                                                        }
                                                        classNamePrefix="select2-selection"
                                                    />

                                                </div>

                                            </Col>


                                            <Col md="4">

                                                <div className="mb-4">

                                                    <Label>
                                                        Program Name{" "}
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </Label>

                                                    <Select
                                                        value={
                                                            selectedProgramName
                                                        }
                                                        onChange={
                                                            handleSelectedProgramName
                                                        }
                                                        options={
                                                            programNameOptions
                                                        }
                                                        classNamePrefix="select2-selection"
                                                    />

                                                </div>

                                            </Col>

                                        </Row>


                                        <Row>

                                            <Col md="4">

                                                <div>

                                                    <Label>
                                                        Technology Name{" "}
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </Label>

                                                    <Select
                                                        value={
                                                            selectedTechnologyName
                                                        }
                                                        onChange={
                                                            handleSelectedTechnology
                                                        }
                                                        options={
                                                            TechnologyOptions
                                                        }
                                                        classNamePrefix="select2-selection"
                                                    />

                                                </div>

                                            </Col>


                                            <Col md="4">

                                                <div className="mb-4">

                                                    <Label>
                                                        Discount Type{" "}
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </Label>

                                                    <Select
                                                        value={
                                                            selectedDiscountType
                                                        }
                                                        onChange={
                                                            handleSelectedDiscountType
                                                        }
                                                        options={
                                                            discountTypeOptions
                                                        }
                                                        classNamePrefix="select2-selection"
                                                    />

                                                </div>

                                            </Col>


                                            <Col md="4">

                                                <div className="mb-4">

                                                    <Label>
                                                        Select Term{" "}
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </Label>

                                                    <Select
                                                        value={
                                                            selectedTermName
                                                        }
                                                        onChange={
                                                            handleSelectedTermName
                                                        }
                                                        options={
                                                            termFeeOptions
                                                        }
                                                        classNamePrefix="select2-selection"
                                                        isDisabled={
                                                            !selectedProgramName?.value
                                                        }
                                                    />

                                                </div>

                                            </Col>


                                            {selectedDiscountType?.value ===
                                                "term" &&
                                                selectedTermName && (

                                                    <>

                                                        <Col md="6">

                                                            <div className="mb-4">

                                                                <Label>
                                                                    Term Fee
                                                                </Label>

                                                                <AvField
                                                                    type="text"
                                                                    name="termFee"
                                                                    value={
                                                                        termFeeDetails.find(
                                                                            (ele) =>
                                                                                ele.term_name ===
                                                                                selectedTermName?.value
                                                                        )?.amount ||
                                                                        ""
                                                                    }
                                                                    disabled
                                                                    className="form-control"
                                                                    style={{
                                                                        backgroundColor:
                                                                            "#f8f9fa",
                                                                        fontWeight:
                                                                            "500"
                                                                    }}
                                                                />

                                                            </div>

                                                        </Col>


                                                        <Col md="6">

                                                            <div className="mb-4">

                                                                <Label>
                                                                    Discount
                                                                </Label>

                                                                <AvField
                                                                    name="discount"
                                                                    type="number"
                                                                    value={
                                                                        termFeeDetails.find(
                                                                            (ele) =>
                                                                                ele.term_name ===
                                                                                selectedTermName.value
                                                                        )?.amount ||
                                                                        ""
                                                                    }
                                                                    disabled
                                                                    className="form-control"
                                                                    id="discount"
                                                                    style={{
                                                                        backgroundColor:
                                                                            "#f8f9fa",
                                                                        fontWeight:
                                                                            "500"
                                                                    }}
                                                                />

                                                            </div>

                                                        </Col>

                                                    </>

                                                )}

                                        </Row>


                                        <Row>

                                            <Col md="6">

                                                <div className="mb-4">

                                                    <Label>
                                                        Enter remarks
                                                    </Label>

                                                    <AvField
                                                        tag="textarea"
                                                        name="remarks"
                                                        id="remarks"
                                                        placeholder="Enter remarks"
                                                        className="form-control"
                                                        rows="3"
                                                        style={{
                                                            resize:
                                                                "none",
                                                            overflowX:
                                                                "hidden",
                                                            overflowY:
                                                                "auto",
                                                            maxHeight:
                                                                "150px"
                                                        }}
                                                    />

                                                </div>

                                            </Col>

                                        </Row>


                                        <Button
                                            color="primary"
                                            type="submit"
                                            disabled={
                                                submitting
                                            }
                                        >

                                            {submitting ? (
                                                <>
                                                    <Spinner
                                                        size="sm"
                                                        className="me-2"
                                                    />

                                                    Processing...
                                                </>
                                            ) : (
                                                "Submit"
                                            )}

                                        </Button>

                                    </AvForm>

                                )}


                            {/* ==================================================
                                BULK DISCOUNT
                            ================================================== */}

                            {discountMode ===
                                "bulk" && (

                                    <div>

                                        {/* ==========================================
                                        SELECTION
                                    ========================================== */}

                                        <Row>

                                            <Col md="4">

                                                <div className="mb-4">

                                                    <Label>
                                                        Select Course{" "}
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </Label>

                                                    <Select
                                                        value={
                                                            selectedCourse
                                                        }
                                                        onChange={
                                                            handleSelectedCourse
                                                        }
                                                        options={
                                                            courseOptions
                                                        }
                                                        classNamePrefix="select2-selection"
                                                    />

                                                </div>

                                            </Col>


                                            <Col md="4">

                                                <div className="mb-4">

                                                    <Label>
                                                        Program Name{" "}
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </Label>

                                                    <Select
                                                        value={
                                                            selectedProgramName
                                                        }
                                                        onChange={
                                                            handleSelectedProgramName
                                                        }
                                                        options={
                                                            programNameOptions
                                                        }
                                                        classNamePrefix="select2-selection"
                                                    />

                                                </div>

                                            </Col>


                                            <Col md="4">

                                                <div className="mb-4">

                                                    <Label>
                                                        Technology{" "}
                                                        <span className="text-danger">
                                                            *
                                                        </span>
                                                    </Label>

                                                    <Select
                                                        value={
                                                            selectedTechnologyName
                                                        }
                                                        onChange={
                                                            handleSelectedTechnology
                                                        }
                                                        options={
                                                            TechnologyOptions
                                                        }
                                                        classNamePrefix="select2-selection"
                                                    />

                                                </div>

                                            </Col>

                                        </Row>


                                        <Row>

                                            <Col md="6">
                                                <div className="mb-4">
                                                    <Label htmlFor="bulkPassoutYear">
                                                        Passout Year{" "}
                                                        <span className="text-danger">*</span>
                                                    </Label>

                                                    <select
                                                        name="bulkPassoutYear"
                                                        id="bulkPassoutYear"
                                                        className="form-control"
                                                        value={bulkPassoutYear}
                                                        onChange={(e) => {
                                                            setBulkPassoutYear(e.target.value);
                                                            resetBulkPreview();
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Passout Year
                                                        </option>

                                                        {passoutYearOptions.map((year) => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </Col>

                                        </Row>


                                        {/* ==========================================
                                        EXCEL UPLOAD
                                    ========================================== */}

                                        <Card
                                            className="border mb-4"
                                        >

                                            <CardBody>

                                                <h5 className="mb-2">
                                                    Upload Bulk Discount Excel
                                                </h5>

                                                <p className="text-muted">
                                                    Excel columns must be:
                                                    <strong>
                                                        {" "}
                                                        roll_no, term_name, remarks
                                                    </strong>
                                                </p>


                                                <div
                                                    className="p-4 text-center"
                                                    style={{
                                                        border:
                                                            "2px dashed #ced4da",
                                                        borderRadius:
                                                            "8px",
                                                        background:
                                                            "#fafafa"
                                                    }}
                                                >

                                                    <Label
                                                        htmlFor="bulkDiscountFile"
                                                        style={{
                                                            cursor:
                                                                "pointer"
                                                        }}
                                                    >

                                                        <div
                                                            style={{
                                                                fontSize:
                                                                    "35px"
                                                            }}
                                                        >
                                                            📄
                                                        </div>

                                                        <div
                                                            style={{
                                                                fontWeight:
                                                                    "600"
                                                            }}
                                                        >
                                                            Choose Excel File
                                                        </div>

                                                        <div
                                                            className="text-muted mt-1"
                                                        >
                                                            .xlsx or .xls
                                                        </div>

                                                    </Label>


                                                    <input
                                                        key={
                                                            bulkFileInputKey
                                                        }
                                                        id="bulkDiscountFile"
                                                        type="file"
                                                        accept=".xlsx,.xls"
                                                        onChange={
                                                            handleBulkFileChange
                                                        }
                                                        style={{
                                                            display:
                                                                "none"
                                                        }}
                                                    />


                                                    {bulkFile && (

                                                        <div
                                                            className="mt-3"
                                                        >

                                                            <div
                                                                className="d-inline-flex align-items-center"
                                                                style={{
                                                                    gap:
                                                                        "10px"
                                                                }}
                                                            >

                                                                <span>
                                                                    📎
                                                                </span>

                                                                <strong>
                                                                    {
                                                                        bulkFile.name
                                                                    }
                                                                </strong>

                                                                <Button
                                                                    type="button"
                                                                    color="danger"
                                                                    size="sm"
                                                                    outline
                                                                    onClick={
                                                                        clearBulkFile
                                                                    }
                                                                >
                                                                    Remove
                                                                </Button>

                                                            </div>

                                                        </div>

                                                    )}

                                                </div>

                                            </CardBody>

                                        </Card>

                                        <div className="mt-3">
                                            <div
                                                style={{
                                                    backgroundColor: "#f8f9fa",
                                                    border: "1px solid #dee2e6",
                                                    borderRadius: "8px",
                                                    padding: "16px"
                                                }}
                                            >
                                                <h6 className="mb-2">
                                                    Excel Format
                                                </h6>

                                                <p
                                                    className="text-muted mb-3"
                                                    style={{ fontSize: "14px" }}
                                                >
                                                    Upload an Excel file with the following columns:
                                                </p>

                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-sm mb-2">
                                                        <thead>
                                                            <tr>
                                                                <th>roll_no</th>
                                                                <th>term_name</th>
                                                                <th>remarks</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            <tr>
                                                                <td>12345</td>
                                                                <td>Term 2</td>
                                                                <td>Director approved</td>
                                                            </tr>

                                                            <tr>
                                                                <td>123456</td>
                                                                <td>Term 3</td>
                                                                <td>Scholarship</td>
                                                            </tr>

                                                            <tr>
                                                                <td>123</td>
                                                                <td>Term 1</td>
                                                                <td>Director approved</td>
                                                            </tr>

                                                            <tr>
                                                                <td>1234</td>
                                                                <td>Term 4</td>
                                                                <td>Scholarship</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div
                                                    className="text-muted"
                                                    style={{ fontSize: "13px" }}
                                                >
                                                    <strong>Required columns:</strong>{" "}
                                                    roll_no, term_name, remarks
                                                </div>

                                                <div
                                                    className="text-muted mt-1"
                                                    style={{ fontSize: "13px" }}
                                                >
                                                    <strong>Note:</strong> Discount amount is automatically
                                                    taken from the selected term fee. Do not add amount or
                                                    discount columns to the Excel file.
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center gap-2 mb-3">
                                            <Button
                                                color="secondary"
                                                outline
                                                type="button"
                                                onClick={() => {
                                                    const link = document.createElement("a");
                                                    link.href = "/bulk_discount_sample.xlsx";
                                                    link.download = "bulk_discount_sample.xlsx";
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    document.body.removeChild(link);
                                                }}
                                            >
                                                <i className="fa fa-download me-2"></i>
                                                Download Sample Excel
                                            </Button>

                                            <span className="text-muted">
                                                Download the template, enter student details, and upload it.
                                            </span>
                                        </div>
                                        {/* ==========================================
                                        VALIDATE BUTTON
                                    ========================================== */}

                                        <div
                                            className="d-flex"
                                            style={{
                                                gap:
                                                    "10px",
                                                flexWrap:
                                                    "wrap"
                                            }}
                                        >

                                            <Button
                                                color="primary"
                                                type="button"
                                                onClick={
                                                    handleValidateBulkDiscounts
                                                }
                                                disabled={
                                                    bulkValidating ||
                                                    bulkApplying
                                                }
                                            >

                                                {bulkValidating ? (
                                                    <>
                                                        <Spinner
                                                            size="sm"
                                                            className="me-2"
                                                        />

                                                        Validating...
                                                    </>
                                                ) : (
                                                    "Validate & Preview"
                                                )}

                                            </Button>


                                            {bulkPreview && (

                                                <Button
                                                    color="secondary"
                                                    type="button"
                                                    onClick={() => {

                                                        setBulkPreview(
                                                            null
                                                        );

                                                        setBulkFile(
                                                            null
                                                        );

                                                        setBulkPassoutYear(
                                                            ""
                                                        );

                                                        setBulkActiveTab(
                                                            "1"
                                                        );

                                                        setBulkFileInputKey(
                                                            Date.now()
                                                        );

                                                    }}
                                                    disabled={
                                                        bulkValidating ||
                                                        bulkApplying
                                                    }
                                                >
                                                    Reset
                                                </Button>

                                            )}

                                        </div>


                                        {/* ==========================================
                                        PREVIEW
                                    ========================================== */}

                                        {bulkPreview && (

                                            <div
                                                className="mt-4"
                                            >

                                                <Card
                                                    className="border"
                                                >

                                                    <CardBody>

                                                        <h5 className="mb-4">
                                                            Bulk Discount Preview
                                                        </h5>


                                                        {/* SUMMARY */}

                                                        <Row>

                                                            <Col
                                                                md="3"
                                                                sm="6"
                                                            >

                                                                <div
                                                                    className="border rounded p-3 mb-3"
                                                                >

                                                                    <div className="text-muted">
                                                                        Total Rows
                                                                    </div>

                                                                    <h4 className="mb-0">
                                                                        {
                                                                            bulkSummary.total_rows
                                                                        }
                                                                    </h4>

                                                                </div>

                                                            </Col>


                                                            <Col
                                                                md="3"
                                                                sm="6"
                                                            >

                                                                <div
                                                                    className="border rounded p-3 mb-3"
                                                                >

                                                                    <div className="text-muted">
                                                                        Valid
                                                                    </div>

                                                                    <h4 className="text-success mb-0">
                                                                        {
                                                                            bulkSummary.valid
                                                                        }
                                                                    </h4>

                                                                </div>

                                                            </Col>


                                                            <Col
                                                                md="3"
                                                                sm="6"
                                                            >

                                                                <div
                                                                    className="border rounded p-3 mb-3"
                                                                >

                                                                    <div className="text-muted">
                                                                        Invalid
                                                                    </div>

                                                                    <h4 className="text-danger mb-0">
                                                                        {
                                                                            bulkSummary.invalid
                                                                        }
                                                                    </h4>

                                                                </div>

                                                            </Col>


                                                            <Col
                                                                md="3"
                                                                sm="6"
                                                            >

                                                                <div
                                                                    className="border rounded p-3 mb-3"
                                                                >

                                                                    <div className="text-muted">
                                                                        Duplicate
                                                                    </div>

                                                                    <h4 className="text-warning mb-0">
                                                                        {
                                                                            bulkSummary.duplicate
                                                                        }
                                                                    </h4>

                                                                </div>

                                                            </Col>

                                                        </Row>


                                                        {/* WARNING */}

                                                        {(Number(
                                                            bulkSummary.invalid
                                                        ) > 0 ||
                                                            Number(
                                                                bulkSummary.duplicate
                                                            ) > 0) && (

                                                                <div
                                                                    className="alert alert-warning"
                                                                    role="alert"
                                                                >

                                                                    <strong>
                                                                        Bulk operation cannot be applied.
                                                                    </strong>

                                                                    <br />

                                                                    Please correct all
                                                                    invalid and duplicate
                                                                    records. The bulk
                                                                    operation is all-or-nothing.

                                                                </div>

                                                            )}


                                                        {/* SUCCESS READY */}

                                                        {canApplyBulk && (

                                                            <div
                                                                className="alert alert-success"
                                                                role="alert"
                                                            >

                                                                <strong>
                                                                    Ready to apply.
                                                                </strong>

                                                                <br />

                                                                {
                                                                    bulkSummary.valid
                                                                }{" "}
                                                                student(s) are ready
                                                                for full term discount.

                                                            </div>

                                                        )}


                                                        {/* TABS */}

                                                        <Nav
                                                            tabs
                                                            className="mb-3"
                                                        >

                                                            <NavItem>

                                                                <NavLink
                                                                    href="#"
                                                                    className={
                                                                        bulkActiveTab ===
                                                                            "1"
                                                                            ? "active"
                                                                            : ""
                                                                    }
                                                                    onClick={(
                                                                        e
                                                                    ) => {

                                                                        e.preventDefault();

                                                                        setBulkActiveTab(
                                                                            "1"
                                                                        );

                                                                    }}
                                                                >
                                                                    Valid (
                                                                    {
                                                                        bulkSummary.valid
                                                                    }
                                                                    )
                                                                </NavLink>

                                                            </NavItem>


                                                            <NavItem>

                                                                <NavLink
                                                                    href="#"
                                                                    className={
                                                                        bulkActiveTab ===
                                                                            "2"
                                                                            ? "active"
                                                                            : ""
                                                                    }
                                                                    onClick={(
                                                                        e
                                                                    ) => {

                                                                        e.preventDefault();

                                                                        setBulkActiveTab(
                                                                            "2"
                                                                        );

                                                                    }}
                                                                >
                                                                    Invalid (
                                                                    {
                                                                        bulkSummary.invalid
                                                                    }
                                                                    )
                                                                </NavLink>

                                                            </NavItem>


                                                            <NavItem>

                                                                <NavLink
                                                                    href="#"
                                                                    className={
                                                                        bulkActiveTab ===
                                                                            "3"
                                                                            ? "active"
                                                                            : ""
                                                                    }
                                                                    onClick={(
                                                                        e
                                                                    ) => {

                                                                        e.preventDefault();

                                                                        setBulkActiveTab(
                                                                            "3"
                                                                        );

                                                                    }}
                                                                >
                                                                    Duplicate (
                                                                    {
                                                                        bulkSummary.duplicate
                                                                    }
                                                                    )
                                                                </NavLink>

                                                            </NavItem>

                                                        </Nav>


                                                        <TabContent
                                                            activeTab={
                                                                bulkActiveTab
                                                            }
                                                        >

                                                            <TabPane tabId="1">

                                                                {renderValidStudents()}

                                                            </TabPane>


                                                            <TabPane tabId="2">

                                                                {renderInvalidStudents()}

                                                            </TabPane>


                                                            <TabPane tabId="3">

                                                                {renderDuplicateStudents()}

                                                            </TabPane>

                                                        </TabContent>


                                                        {/* APPLY */}

                                                        <div
                                                            className="mt-4 d-flex justify-content-end"
                                                        >

                                                            <Button
                                                                color="success"
                                                                type="button"
                                                                onClick={
                                                                    handleApplyBulkDiscounts
                                                                }
                                                                disabled={
                                                                    !canApplyBulk ||
                                                                    bulkApplying ||
                                                                    bulkValidating
                                                                }
                                                            >

                                                                {bulkApplying ? (
                                                                    <>
                                                                        <Spinner
                                                                            size="sm"
                                                                            className="me-2"
                                                                        />

                                                                        Applying Discounts...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        Apply Bulk Discounts
                                                                        {canApplyBulk &&
                                                                            ` (${bulkSummary.valid})`}
                                                                    </>
                                                                )}

                                                            </Button>

                                                        </div>

                                                    </CardBody>

                                                </Card>

                                            </div>

                                        )}

                                    </div>

                                )}

                        </CardBody>

                    </Card>

                </Col>

            </Row>

        </React.Fragment>
    );
};


export default connect(
    null,
    { setBreadcrumbItems }
)(AddCourseDiscount);